import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_asoProject",
  ref: "addAsoProjectModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_asoProject_header"
}
const _hoisted_5 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_7 = {
  id: "kt_modal_add_asoProject_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_asoProject_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_asoProject_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_asoProject_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_11 = { class: "fv-row mb-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Name", -1)
const _hoisted_13 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Client")
], -1)
const _hoisted_15 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "OS")
], -1)
const _hoisted_17 = { class: "fv-row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "App ID", -1)
const _hoisted_19 = { class: "fv-row mb-7" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Countries", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column mb-7 fv-row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Console")
], -1)
const _hoisted_22 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Console")
], -1)
const _hoisted_24 = { class: "fv-row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Console Spreadhseet", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column mb-7 fv-row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "AppTweak")
], -1)
const _hoisted_27 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Account")
], -1)
const _hoisted_29 = { class: "fv-row mb-7" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Keywords Distribution, Top Charts, and Ratings Spreadhsheet", -1)
const _hoisted_31 = { class: "modal-footer flex-center" }
const _hoisted_32 = ["data-kt-indicator"]
const _hoisted_33 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_35 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_36 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.formData.id == 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Add ASO Project"))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, "Edit ASO Project: " + _toDisplayString(_ctx.formData.name), 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.client_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.client_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.api.clients, (client) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: client.name,
                          value: client.id,
                          key: client
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.os,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.os) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oses, (os) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: os.id,
                          label: os.name,
                          value: os.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.app,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.app) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_form_item, { prop: "countries" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.countries,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.countries) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.console_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.console_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consoleIntegrations, (console) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: console.user,
                          value: console.id,
                          key: console
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_form_item, { prop: "console_spreadsheet" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.console_spreadsheet,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.console_spreadsheet) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.apptweak_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.apptweak_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apptweakIntegrations, (apptweak) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: apptweak.user,
                          value: apptweak.id,
                          key: apptweak
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_el_form_item, { prop: "ratings_topcharts_spreadsheet" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.aso_spreadsheet,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.aso_spreadsheet) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _hoisted_39))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_32)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}